$(document).ready(() => {
    const $form = $('#outofstocknotifyForm');
    const $submitButton = $('#outOfStockNotifySubmit');
    const $emailInput = $('#outOfStockNotifyEmailInput');
    const $feedback = $('#outOfStockNotifyFeedback');
    const $outOfStockNotice = $form.closest('.out-of-stock-notice');

    $emailInput.on('input', function () {
        const email = $(this).val();

        if (!/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(email)) {
            $submitButton.prop('disabled', true);
            $feedback.removeClass('d-none');
        } else {
            $submitButton.prop('disabled', false);
            $feedback.addClass('d-none');
        }
    });

    $form.on('submit', function (e) {
        e.preventDefault();

        const emailInput = $('input[name="email"]', $form).val();

        if (!/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(emailInput)) {
            $feedback.text('Invalid E-mail!');
            $feedback.removeClass('d-none');
            return;
        }

        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            data: $(this).serialize(),
            success: (data) => {
                if (data.success) {
                    $('#outOfStockNotifyModal').on('hidden.bs.modal', () => {
                        $outOfStockNotice.text(data.msg);
                    }).modal('hide');
                } else {
                    $feedback.text(data.msg);
                    $feedback.removeClass('d-none');
                }
            },
            error: (err) => {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $feedback.text(err.responseJSON.message);
                    $feedback.removeClass('d-none');
                }
            },
        });
        return false;
    });
});
